//
//
//
//
//
//
//

export default{
  data () {
    return {
      phone: '',
	  memberId:''
    }
  },
  onLoad (event) {
    this.phone = event.phone
  },
  methods: {
    finish () {
      this.$ajax({
        method: 'post',
        url: '/weChat/member/updateById',
        data: {
          phone: this.phone,
          memberId: this.$store.state.userInfo.id
        }
      }).then(res=>{
		  uni.navigateBack({
		    delta: 2
		  })
	  })
    }
  }
}
